import React from 'react';
import { unwrapModel } from '../../../services/api/unwrapModel';
import { useGetAllActionTypesSuspense, useGetAllHazardsSuspense, } from '../../../services/api/generated/client';
import OfficerAssessmentDetailsForm from './OfficerAssessmentDetailsForm';
const OfficerAssessmentDetailsFormWrapper = ({ canEdit }) => {
    const { data: hazardsResponse } = useGetAllHazardsSuspense({
        query: { staleTime: Infinity },
    });
    const { data: actionTypesResponse } = useGetAllActionTypesSuspense({
        query: { staleTime: Infinity },
    });
    const hazards = unwrapModel(hazardsResponse);
    const actionTypes = unwrapModel(actionTypesResponse);
    if (!hazards || !actionTypes) {
        return null;
    }
    return (React.createElement(OfficerAssessmentDetailsForm, { hazards: hazards, actionTypes: actionTypes, canEdit: canEdit }));
};
export default OfficerAssessmentDetailsFormWrapper;
